import styled from "styled-components";

export const Header = styled.div`
  background-color: var(--fd-colors-background-layer);
  padding: var(--fd-space-space-2) var(--fd-space-space-4);
`;
